import { getFavouriteBrands } from './getFavouriteBrands';
import { addFavouriteBrands } from './addFavouriteBrands';
import { deleteFavouriteBrands } from './deleteFavouriteBrands';
import { resetDeleteFavouriteBrandsStatus } from './resetDeleteFavouriteBrandsStatus';
import { updateAddingFavouriteBrandsStatus } from './updateAddingFavouriteBrandsStatus';

export const brandsOperations = {
  getFavouriteBrands,
  addFavouriteBrands,
  deleteFavouriteBrands,
  resetDeleteFavouriteBrandsStatus,
  updateAddingFavouriteBrandsStatus
};